import React from 'react';
import { usePremiumProductAccess } from '../hooks/usePremiumProductAccess';
import PremiumAccessPrompt from './PremiumAccessPrompt';

export default function PremiumProductRouteGate({ productKey, children }) {
  const access = usePremiumProductAccess(productKey);

  if (access.isAllowed) {
    return children;
  }

  return <PremiumAccessPrompt variant="page" {...access.routePromptProps} />;
}
